export const KILOMETERS_IN_MILE = 1.60934;
export const SPEED_FORMATS = ['kph', 'mph'] as const;

// Backend stores speed in KPH. Convert to display unit.
export const toDisplaySpeed = (
  kph: number,
  format: (typeof SPEED_FORMATS)[number]
): number =>
  format === 'kph'
    ? kph
    : Number.parseFloat((kph / KILOMETERS_IN_MILE).toFixed(1));

// Convert a user-entered display value back to KPH for the backend.
export const fromDisplaySpeed = (
  value: number,
  format: (typeof SPEED_FORMATS)[number]
): number =>
  format === 'kph'
    ? value
    : Number.parseFloat((value * KILOMETERS_IN_MILE).toFixed(1));
export const MAX_BAR_SIZE = 120;

export const MAP_MAX_ZOOM = 19;

export const AUTO_REFRESH_PERIODS = [30, 60, 120];

export const AUTO_REFRESH_OPTIONS: {value: number | null; label: string}[] = [
  {value: null, label: 'None'},
  ...AUTO_REFRESH_PERIODS.map((s) => ({value: s * 1000, label: String(s)})),
];

export const AUTO_REFRESH_SELECT_ITEMS: (string | number)[] = [
  'None',
  ...AUTO_REFRESH_PERIODS,
];
